export const CreditsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 11C11.2386 11 9 9.8807 9 8.5C9 7.11929 11.2386 6 14 6C16.7614 6 19 7.11929 19 8.5C19 9.8807 16.7614 11 14 11Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12.5C9 13.8807 11.2386 15 14 15C16.7614 15 19 13.8807 19 12.5"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 7.5C1 8.8807 3.23858 10 6 10C7.12583 10 8.1647 9.814 9.0005 9.5"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 11C1 12.3807 3.23858 13.5 6 13.5C7.12561 13.5 8.1643 13.314 9 13.0002"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 3.5V14.5C1 15.8807 3.23858 17 6 17C7.12563 17 8.1643 16.8139 9 16.5"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 6.5V3.5"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 8.5V16.5C9 17.8807 11.2386 19 14 19C16.7614 19 19 17.8807 19 16.5V8.5"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6C3.23858 6 1 4.88071 1 3.5C1 2.11929 3.23858 1 6 1C8.7614 1 11 2.11929 11 3.5C11 4.88071 8.7614 6 6 6Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
